import { IEnvironment } from "./environment.d";

export const environment: IEnvironment = {
  production: true,
  api: "api.value-iq.com:3000",
  protocol: "https",
  language: "de",
};
